import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Route, Switch } from 'react-router-dom';

const Cobranca = asyncComponent(() => import('../cobranca'));
const CadastroDevedor = asyncComponent(() =>
  import('../cadastros/devedores/DadosDevedores')
);
const Devedores = asyncComponent(() =>
  import('../cadastros/devedores/ListaDevedores')
);

const Processo = asyncComponent(() => import('../cobranca/processo'));
const ProcessoError401 = asyncComponent(() =>
  import('../cobranca/processo/Error401')
);
const Acionar = asyncComponent(() =>
  import('../cobranca/acionar/ListaAcionar')
);
const Agenda = asyncComponent(() => import('../cobranca/agenda/ListaAgenda'));
const Acordo = asyncComponent(() => import('../cobranca/acordo/ListaAcordo'));
const InstrucaoOnline = asyncComponent(() =>
  import('../cobranca/instrucao-online')
);
const Mensagens = asyncComponent(() =>
  import('../cobranca/Mensagens')
);
const Ocorrencias = asyncComponent(() =>
  import('../relatorios/02Ocorrencias/0201Ocorrencias')
);
const ModeloDeOcorrencias = asyncComponent(() =>
  import('../cobranca/modelo-ocorrencia')
);
const AcordosLiberados = asyncComponent(() =>
  import('../cobranca/diversos/AcodosLiberados/ListaAcordosLiberados')
);
const ListaPropostasRealizadas = asyncComponent(() =>
  import(`../cobranca/PropostasRealizadas/ListaPropostas`)
);
const RelatorioComissao = asyncComponent(() => import('../cobranca/comissao'));

const Boletos = asyncComponent(() =>
  import('../financeiro/boletos/ListaBoletos')
);
const Pix = asyncComponent(() => import('../financeiro/pix/ListaPix'));
const BloqueadosIdentificar = asyncComponent(() =>
  import(
    '../financeiro/recebimentos/BloqueadosIdentificar/BloqueadosIdentificar'
  )
);

const ControleDeAcessoSuporte = asyncComponent(() =>
  import('../config/controle-de-acesso-suporte')
);

export default function CobrancaRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/cob/devedores/cadastro/:id`}
          component={CadastroDevedor}
          codigo="cad_devedor_a"
        />
        <PrivateRoute
          path={`${match.url}/cob/devedores/cadastro`}
          component={CadastroDevedor}
          codigo="cad_devedor_c"
        />
        <PrivateRoute
          path={`${match.url}/cob/devedores`}
          component={Devedores}
          codigo="cad_devedor_v"
        />
        <Route path={`${match.url}/cob/processo/:id`} component={Processo} />
        <Route
          path={`${match.url}/cob/processo-acesso-negado`}
          component={ProcessoError401}
        />
        <PrivateRoute
          path={`${match.url}/cob/acionar`}
          component={Acionar}
          codigo="cob_acionar"
        />
        <PrivateRoute
          path={`${match.url}/cob/agenda`}
          component={Agenda}
          codigo="cob_agenda_ret"
        />
        <PrivateRoute
          path={`${match.url}/cob/acordo`}
          component={Acordo}
          codigo="cob_acordos_prog"
        />
        <PrivateRoute
          path={`${match.url}/cob/ocorrencias`}
          component={Ocorrencias}
          codigo="rel_02"
        />
        <PrivateRoute
          path={`${match.url}/cob/instrucao-online`}
          component={InstrucaoOnline}
          codigo="instrucao_online"
        />
        <PrivateRoute
          path={`${match.url}/cob/mensagens`}
          component={Mensagens}
          codigo="mensagens.colab"
        />
        <PrivateRoute
          path={`${match.url}/cob/boletos`}
          component={Boletos}
          codigo="fin_bol_vis"
        />
        <PrivateRoute
          path={`${match.url}/cob/pix`}
          component={Pix}
          codigo="cob_pix"
        />
        <PrivateRoute
          path={`${match.url}/cob/bloqueados-identificar`}
          component={BloqueadosIdentificar}
          codigo="cob_recident"
        />
        <PrivateRoute
          path={`${match.url}/cob/modelos-ocorrencias`}
          component={ModeloDeOcorrencias}
          codigo="cob_modelo_oco"
        />
        <PrivateRoute
          path={`${match.url}/cob/acordos-liberados`}
          component={AcordosLiberados}
          codigo="cob_acordos_lib"
        />
        <PrivateRoute
          path={`${match.url}/cob/propostas-realizadas`}
          component={ListaPropostasRealizadas}
          codigo="cob_propostas"
        />
        <PrivateRoute
          path={`${match.url}/cob/relatorio-comissao`}
          component={RelatorioComissao}
          codigo="cob_comissao"
        />
        <Route path={`${match.url}/cob/inicio`} component={Cobranca} />
        <Route
          path={`${match.url}/cob/suporte-tecnico`}
          component={ControleDeAcessoSuporte}
        />
        <Route exact path={`${match.url}/cob`} component={Cobranca} />
      </Switch>
    </>
  );
}
